// Pre-built Project GLAD® pathway templates.
// The dashboard offers these in a gallery; picking one navigates to the
// builder with ?template=<id> so the builder can pre-fill title/subtitle/track
// and (where applicable) suggest a starter module set.

export const GLAD_PATHWAY_TEMPLATES = [
  {
    id: 'blank',
    name: 'Blank pathway',
    description: 'Start from a clean canvas. Add your own modules and rules.',
    track: '',
    title: '',
    subtitle: '',
    duration: '—',
    moduleHint: 'No modules — bring your own',
    accent: 'gray',
    icon: 'plus',
  },
  {
    id: 'foundations',
    name: 'GLAD® Foundations Pathway',
    description: 'Core strategies for academic language development. Ideal for educators new to GLAD®.',
    track: 'foundations',
    title: 'GLAD® Foundations Pathway',
    subtitle: 'Core strategies for academic language development',
    duration: '~3 hrs',
    moduleHint: '5 starter modules',
    accent: 'violet',
    icon: 'book',
  },
  {
    id: 'trainer-cert',
    name: 'GLAD® Trainer Certification',
    description: 'Prepare to train and coach GLAD® educators in your region.',
    track: 'foundations',
    title: 'GLAD® Trainer Certification',
    subtitle: 'Prepare to train and coach GLAD® educators in your region',
    duration: '~6 hrs',
    moduleHint: '8 starter modules',
    accent: 'green',
    icon: 'award',
  },
  {
    id: 'coaching-cycle',
    name: 'Coaching & Implementation Cycle',
    description: 'For instructional coaches supporting GLAD® rollout in their site or district.',
    track: 'coaching',
    title: 'Coaching & Implementation Cycle',
    subtitle: 'A 6-week cycle for coaches supporting GLAD® classrooms',
    duration: '~4 hrs',
    moduleHint: '6 starter modules',
    accent: 'amber',
    icon: 'users',
  },
  {
    id: 'new-educator',
    name: 'New Educator Onboarding',
    description: 'First-year GLAD® classroom essentials — strategies, planning, and reflection.',
    track: 'foundations',
    title: 'New Educator Onboarding',
    subtitle: 'First-year GLAD® classroom essentials',
    duration: '~2 hrs',
    moduleHint: '4 starter modules',
    accent: 'pink',
    icon: 'sparkles',
  },
  {
    id: 'leadership',
    name: 'Leadership for GLAD® Adoption',
    description: 'For RTC and site leaders launching GLAD® across teams. Strategy, change management, and measurement.',
    track: 'leadership',
    title: 'Leadership for GLAD® Adoption',
    subtitle: 'Launching GLAD® across teams and tracking impact',
    duration: '~3 hrs',
    moduleHint: '5 starter modules',
    accent: 'indigo',
    icon: 'compass',
  },
];

export function getGladTemplate(id) {
  return GLAD_PATHWAY_TEMPLATES.find(t => t.id === id) || null;
}
